import { CheckCircle2, Droplets, Sparkles } from 'lucide-react'
import { CoatingIncludesSection } from '../protection/coating-includes-section'
import { CompleteProtectionPreview } from '../protection/complete-protection-preview'
import { ProtectionSelector } from '../protection/protection-selector'
import { WarrantyInformationSection } from '../protection/warranty-information-section'
import { PageShell } from '../layout/page-shell'
import { PageTitle } from '../seo/page-title'
import { ButtonLink } from '../ui/button'
import { getServicePageJsonLd } from '../../lib/seo'

export interface CeramicProtectionPageProps {}

export function CeramicProtectionPage(_: Readonly<CeramicProtectionPageProps>) {
  const jsonLd = getServicePageJsonLd('ceramic')

  return (
    <PageShell>
      <PageTitle title="Ceramic Coating Bellarine & Geelong | Autoglow Detailing" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <section className="packages-hero">
        <img
          src="/images/page-assets/packages-hero.jpg"
          alt="Ceramic-coated performance vehicle with water beading under studio light."
          width="2560"
          height="1440"
        />
        <div className="packages-hero-content">
          <p className="eyebrow">GYEON Certified</p>
          <h1>
            Ceramic Coating <span>Bellarine &amp; Geelong</span>
          </h1>
          <p>
            Professional GYEON ceramic coatings installed in Drysdale for Geelong and Bellarine
            vehicles. Every coating includes safe preparation and a complimentary vehicle inspection.
          </p>
          <div>
            <ButtonLink href="/book">Book Ceramic Protection</ButtonLink>
            <ButtonLink href="/contact" variant="ghost">Request a Free Quote</ButtonLink>
          </div>
        </div>
      </section>

      <section className="package-intro" id="technical">
        <div className="section-container package-intro-grid">
          <div className="package-product-card">
            <img
              src="/images/page-assets/gyeon-product.jpg"
              alt="GYEON ceramic coating product bottle on a carbon fibre surface."
              width="900"
              height="900"
            />
            <div>
              <CheckCircle2 size={20} aria-hidden="true" />
              <span>GYEON CERTIFIED</span>
              <strong>Professional Installation</strong>
            </div>
          </div>
          <div className="package-copy">
            <p className="eyebrow">Professional Ceramic Protection</p>
            <h2>Gloss, hydrophobic performance and easier maintenance</h2>
            <p>
              Autoglow installs current GYEON ceramic coatings after safe preparation and a
              complimentary vehicle inspection. Durability, finish and protection are matched to the
              vehicle during booking or a complimentary inspection.
            </p>
            <div className="feature-pair-grid">
              <article>
                <Droplets aria-hidden="true" />
                <h3>Hydrophobic</h3>
                <p>Helps repel water, dirt and road grime so regular maintenance is easier.</p>
              </article>
              <article>
                <Sparkles aria-hidden="true" />
                <h3>Premium Gloss</h3>
                <p>Designed for a deep, high-gloss finish when paired with correct paint preparation.</p>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="packages-list-section" id="packages">
        <div className="section-container">
          <div className="page-section-heading">
            <h2>Choose Your Level of Protection</h2>
            <p>
              Select your GYEON ceramic protection level. Every coating starts with safe preparation
              and a complimentary vehicle inspection.
            </p>
          </div>
          <ProtectionSelector />
        </div>
      </section>

      <CoatingIncludesSection />
      <WarrantyInformationSection />
      <CompleteProtectionPreview />
    </PageShell>
  )
}

export default CeramicProtectionPage
